import { useState, useCallback } from 'react';
import { useSavedFilterContext } from '../contexts/savedFiltersContext';

export const useSavedFilterEdit = () => {
  const { savedFilters } = useSavedFilterContext();

  const [editingId, setEditingId] = useState<string | null>(null);

  const onCancel = useCallback(() => {
    setEditingId(null);
  }, []);

  const onSave = useCallback(
    ({ title, includeColumns }: { title: string; includeColumns: boolean }) => {
      if (!title) {
        return;
      }
      setEditingId(null);
      savedFilters.editSavedFilter({ id: editingId!, name: title, includeColumns });
    },
    [editingId, savedFilters]
  );

  return {
    editingId,
    setEditingId,
    onCancel,
    onSave,
  };
};
